import { useContext } from 'react'
import { PaginationProvider } from '../../providers/PaginationProvider/PaginationProvider'
import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'
import UserContext from '../../context/User/User'
import AuthService from '../../utilities/services/auth.service'
import { checkPermission } from '../../utilities/helpers'
import { ORGANIZATION_PERMISSION_SLUGS } from '@blocktickets/shared-utils'
import { NoPermissionsContainer } from '../../components/NoPermissionsContainer'
import { PageLoadingContainer } from '../../components/PageLoadingContainer'

import { AccountInformationWrapper } from '../../components'

export default function PayoutsReportPage() {
  const { orgPermissions } = useContext(UserContext)
  const { getPermissions } = AuthService

  const orgPermissionsReady = orgPermissions?.length > 0
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.VIEW_BALANCE_PAYOUTS
    )

  if (!orgPermissionsReady) {
    return <PageLoadingContainer style="without-sidebar" />
  }

  if (!hasPermission) {
    return <NoPermissionsContainer />
  }

  return (
    <div className="spacer-sm">
      <PaginationProvider>
        <ModalProvider>
          <AccountInformationWrapper />
        </ModalProvider>
      </PaginationProvider>
    </div>
  )
}
